import styled from 'styled-components';

import {Button} from '@yourcoach/shared/uikit/Button';
import {View} from '@yourcoach/shared/uikit/View';

export const Container = styled(View)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 25px 0;
`;

export const LoginButton = styled(Button).attrs({size: 'l'})`
  padding-left: 30px;
  padding-right: 30px;
  font-weight: 600;
`;
